import { Entity, LoadingState } from '@zdr-tools/zdr-entities';
/** Why the trip page has no trip to show. */
export var TripLoadFailure;
(function (TripLoadFailure) {
    TripLoadFailure["NONE"] = "NONE";
    /** No trip with this id belongs to the owner (missing, another account's, or a malformed id). */
    TripLoadFailure["NOT_FOUND"] = "NOT_FOUND";
    /** The server could not be reached or failed. */
    TripLoadFailure["UNAVAILABLE"] = "UNAVAILABLE";
})(TripLoadFailure || (TripLoadFailure = {}));
const NO_TRIP_ID = '';
/** The trip page: which trip it shows, its load, the trip itself, and the page's 2 in-place edits. */
export class TripPage extends Entity {
    titleEdit;
    noteEdit;
    tripId;
    loadingState;
    loadFailure;
    trip;
    constructor(titleEdit, noteEdit) {
        super('trip-page');
        this.titleEdit = titleEdit;
        this.noteEdit = noteEdit;
        this.tripId = this.createPropEventBroker('tripId', NO_TRIP_ID);
        this.loadingState = this.createPropEventBroker('loadingState', LoadingState.IDLE);
        this.loadFailure = this.createPropEventBroker('loadFailure', TripLoadFailure.NONE);
        this.trip = this.createPropEventBroker('trip', undefined);
        this.addSubEntity(titleEdit);
        this.addSubEntity(noteEdit);
    }
    getEntityName() {
        return 'TripPage';
    }
    getTitleEdit() {
        return this.titleEdit;
    }
    getNoteEdit() {
        return this.noteEdit;
    }
    markLoading(tripId) {
        this.titleEdit.close();
        this.noteEdit.close();
        this.tripId.set(tripId);
        this.trip.set(undefined);
        this.loadFailure.set(TripLoadFailure.NONE);
        this.loadingState.set(LoadingState.LOADING);
    }
    markLoaded(trip) {
        this.trip.set(trip);
        this.loadingState.set(LoadingState.DONE);
    }
    markNotFound() {
        this.trip.set(undefined);
        this.loadFailure.set(TripLoadFailure.NOT_FOUND);
        this.loadingState.set(LoadingState.ERROR);
    }
    markFailed() {
        this.loadFailure.set(TripLoadFailure.UNAVAILABLE);
        this.loadingState.set(LoadingState.ERROR);
    }
    acceptCurrentTrip(trip) {
        if (trip.getId() === this.tripId.get()) {
            this.trip.set(trip);
        }
    }
}
//# sourceMappingURL=TripPage.js.map